import {
  Stack,
  List,
  ListItem,
  DialogContent,
  ListItemText,
  Divider,
  IconButton,
  Typography,
  Tooltip,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import React from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import HelpIcon from "@mui/icons-material/Help";

import { styles } from "./styles";

const resourcesCourses = [
  {
    name: "BoatU.S. Foundation",
    url: "https://www.boatus.org/free",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "NASBLA",
    url: " https://www.nasbla.org/education/taking-a-boat-course",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "NauticEd - USCG Certified",
    url: "https://www.nauticed.org/argo-nauticed-boating-courses?affiliate=argo-navigation&utm_medium=app&utm_source=argo&utm_campaign=boating-safety",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "U.S. Coast Guard Auxiliary",
    url: "https://www.cgaux.org/boatinged",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "U.S. Power Squadrons (America's Boating Club)",
    url: "https://www.usps.org/sss-boating-courses",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
];

const resourcesSafety = [
  {
    name: "Float Plan",
    url: "https://floatplancentral.cgaux.org/download/USCGFloatPlan.pdf",
    info: "This provides a fillable PDF. You can also share your route from your Captain's Log on the mobile app and list the passengers onboard in your message or post.",
    icon: <DescriptionIcon sx={styles.icon} />,
  },
  {
    name: "Navigation & Safety Information",
    url: "https://navcen.uscg.gov/maritime-safety-information",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "Rules of the Road",
    url: "https://www.navcen.uscg.gov/sites/default/files/pdf/navRules/Nav%20Rules%20Handbook_27OCT2022_85%20FR%2058268.pdf",
    info: undefined,
    icon: <DescriptionIcon sx={styles.icon} />,
  },
  {
    name: "Rules of the Road - Quick Reference",
    url: "https://www.whoi.edu/wp-content/uploads/2020/04/Abbreviated-Guide-To-Navigation-Rules-of-the-Road.pdf ",
    info: undefined,
    icon: <DescriptionIcon sx={styles.icon} />,
  },
  {
    name: "Vessel Safety Checks",
    url: "https://cgaux.org/vsc/",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
];

const resourcesAdvice = [
  {
    name: "Autorouting, Rule 9, and the Importance of Staying Situationally Aware",
    url: "https://argonav.io/autorouting-rule-9-and-the-importance-of-staying-situationally-aware/",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "Boating at Night",
    url: "https://argonav.io/safety-tips-for-overnight-cruising/",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
  {
    name: "Using Your VHF Radio",
    url: "https://argonav.io/proper-vhf-radio-etiquette/",
    info: undefined,
    icon: <LanguageIcon sx={styles.icon} />,
  },
];

function BseModal() {
  return (
    <DialogContent sx={styles.dialogContent}>
      <Stack spacing={2}>
        <List aria-label="mailbox folders" sx={styles.list}>
          <ListItem>
            <ListItemText>
              <Typography sx={styles.title} variant="subtitle2">
                Boating Courses
              </Typography>
            </ListItemText>
          </ListItem>
          {resourcesCourses.map((resource, index) => (
            <>
              <ListItem
                key={resource.name}
                secondaryAction={
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    edge="end"
                    onClick={() => window.open(resource.url, "_blank")}
                  >
                    {resource.icon}
                  </IconButton>
                }
                sx={{ cursor: "pointer" }}
                onClick={() => window.open(resource.url, "_blank")}
              >
                <ListItemText>
                  <Typography variant="body2">{resource.name}</Typography>
                </ListItemText>
              </ListItem>
              {index < resourcesCourses.length - 1 && <Divider component="li" />}
            </>
          ))}
        </List>
        <List aria-label="mailbox folders" sx={styles.list}>
          <ListItem>
            <ListItemText>
              <Typography sx={styles.title} variant="subtitle2">
                Boating Safety
              </Typography>
            </ListItemText>
          </ListItem>
          {resourcesSafety.map((resource, index) => (
            <>
              <ListItem
                key={resource.name}
                secondaryAction={
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    edge="end"
                    onClick={() => window.open(resource.url, "_blank")}
                  >
                    {resource.icon}
                  </IconButton>
                }
                sx={{ cursor: "pointer" }}
                onClick={() => window.open(resource.url, "_blank")}
              >
                <ListItemText>
                  <Typography
                    sx={resource.info ? { display: "flex", alignItems: "center" } : {}}
                    variant="body2"
                  >
                    {resource.name}{" "}
                    {resource.info && (
                      <Tooltip arrow placement="top" title={resource.info}>
                        <IconButton color="primary" edge="end" size="small">
                          <HelpIcon sx={styles.infoIcon} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Typography>
                </ListItemText>
              </ListItem>
              {index < resourcesSafety.length - 1 && <Divider component="li" />}
            </>
          ))}
        </List>
        <List aria-label="mailbox folders" sx={styles.list}>
          <ListItem>
            <ListItemText>
              <Typography sx={styles.title} variant="subtitle2">
                Helpful Advice
              </Typography>
            </ListItemText>
          </ListItem>
          {resourcesAdvice.map((resource, index) => (
            <>
              <ListItem
                key={resource.name}
                secondaryAction={
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    edge="end"
                    onClick={() => window.open(resource.url, "_blank")}
                  >
                    {resource.icon}
                  </IconButton>
                }
                sx={{ cursor: "pointer" }}
                onClick={() => window.open(resource.url, "_blank")}
              >
                <ListItemText>
                  <Typography variant="body2">{resource.name}</Typography>
                </ListItemText>
              </ListItem>
              {index < resourcesAdvice.length - 1 && <Divider component="li" />}
            </>
          ))}
        </List>
      </Stack>
    </DialogContent>
  );
}

export default BseModal;
